<template>
  <div
    v-if="isOrderRidesMapBasedTest === undefined"
    v-loading="true"
    class="ride-ordering-loading page-content"
    element-loading-custom-class="custom-spinner-class"
  />
  <MapBasedRideOrdering v-else-if="isOrderRidesMapBasedTest" />
  <RideOrdering v-else />
</template>

<script setup lang="ts">
import RideOrdering from './RideOrdering.vue';
import MapBasedRideOrdering from './MapBasedRideOrdering.vue';

import { isOrderRidesMapBasedTest } from '@/services/operators/viewModel';
</script>

<style lang="scss" scoped>
.ride-ordering-loading {
  min-height: calc(100vh - 60px);
}
</style>
